import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContext, getSelectedLocation, getEventMessage, getLocation, setSelectedLocation, } from '../workspaces/redux/spaces-slice';
import { BuildingView } from './building';
import FloorView from './floor/layout';
import { NavigatorView } from './navigator';
import { resolveActiveFloorLocation, sendLogsToServer, smartRoomsCall, } from './floor/util';
import { getSmartRooms } from '../../store/uislice';
import { useStatusQuery } from './service/domain-api';
import { DataService } from '../configure/service/deviceservice';
import Loader from '../../common/loader/loader';
import { isRegistered, setToken, clearError } from '../../store/authslice';
import Error from '../../common/error/error';
import NatsClient from '../../store/natsclient';
import { loadPage } from '../../common/util';
export function Workspaces() {
    const dispatch = useDispatch();
    const dataService = new DataService();
    const registered = useSelector((state) => state.auth.registered);
    const contextData = useSelector((state) => state.auth.contextData);
    const currntviewToken = useSelector((state) => state.auth.token);
    const viewType = useSelector((state) => state.auth.viewType);
    const error = useSelector((state) => state.auth.error);
    const [skip, setSkip] = useState(false);
    const statusAPIUrl = `${window.location.origin}/v1/${dataService.getDeviceToken()}/status`;
    const { data: statusData } = useStatusQuery(statusAPIUrl, { skip });
    const selectedLocation = useSelector(getSelectedLocation);
    const locationData = useSelector(getLocation);
    const contextInfo = useSelector(getContext);
    const eventMessage = useSelector(getEventMessage);
    const tenantId = contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.tenantId;
    const isSmartRoomsCallMade = useSelector(getSmartRooms).length != 0;
    const [shouldPendoInitialize, setShouldPendoInitialize] = useState(false);
    if (tenantId && !isSmartRoomsCallMade)
        smartRoomsCall(tenantId);
    useEffect(() => {
        var _a;
        const locationChildren = (_a = locationData === null || locationData === void 0 ? void 0 : locationData.children) !== null && _a !== void 0 ? _a : [];
        if (locationChildren.length === 0) {
            return;
        }
        const selectedLocationExists = selectedLocation
            ? locationChildren.some((child) => child.id === selectedLocation)
            : false;
        if (selectedLocationExists) {
            return;
        }
        if (!selectedLocation && (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.viewType) !== 'floor') {
            return;
        }
        const { floorLocationId } = resolveActiveFloorLocation(locationData, contextInfo, selectedLocation);
        if (floorLocationId && floorLocationId !== selectedLocation) {
            dispatch(setSelectedLocation(floorLocationId));
        }
    }, [contextInfo, dispatch, locationData, selectedLocation]);
    useEffect(() => {
        if (!registered) {
            // console.log(
            //   'Device not Registered.Inititating devce registration call with public key',
            //   registered
            // );
            dispatch(isRegistered(registered));
        }
    }, []);
    useEffect(() => {
        if (contextInfo === null || contextInfo === void 0 ? void 0 : contextInfo.shouldPendoInitialize) {
            setShouldPendoInitialize(contextInfo.shouldPendoInitialize);
        }
    }, [contextInfo]);
    useEffect(() => {
        if (shouldPendoInitialize) {
            const { tenantId, customerName, pendoExtra = {} } = contextInfo;
            const { pendoVisitorExtra = {}, pendoAccountExtra = {} } = pendoExtra;
            const baseUrl = location.host;
            const token = dataService.getDeviceToken();
            const pendo = 'pendo';
            // const { iframeMessage = {} } = state;
            // const {
            //   type: iframeMsgType = null,
            //   // data: iframeMsgData = null
            // } = iframeMessage;
            // let hosted = 'WebexBoard';
            // if (iframeMessage && iframeMsgType && iframeMsgType === 'setToken@dnas-sw') {
            //   hosted = 'WebApp';
            // }
            console.log('pendo values', `${token}_${tenantId}_${baseUrl}`);
            if (window[pendo]) {
                const pendoParams = {
                    visitor: Object.assign({ id: `${token}_${tenantId}_${baseUrl}` }, pendoVisitorExtra),
                    account: Object.assign({ id: `${tenantId}_${baseUrl}`, customerName }, pendoAccountExtra),
                };
                window[pendo].initialize(pendoParams);
                console.log('pendo initialised', pendoParams);
            }
        }
    }, [shouldPendoInitialize]);
    useEffect(() => {
        if (!contextData && registered) {
            const token = dataService.getDeviceToken()
                ? dataService.getDeviceToken()
                : dataService.getDeviceToken();
            console.log('Context info not available yet. Inititating context info call', contextData);
            // console.log('Context info token is ', token);
            dispatch(setToken(token));
        }
        else if (registered && currntviewToken !== dataService.getDeviceToken()) {
            // console.log('Token is not same as the one in local storage');
            dataService.setDeviceToken(dataService.getDeviceToken());
        }
    }, [registered, dataService.getDeviceToken()]);
    useEffect(() => {
        console.log('Event message recieved:', eventMessage);
        if (eventMessage.data && eventMessage.event) {
            const eventData = eventMessage.data;
            const eventType = eventMessage.event;
            const messageTime = eventData.timestamp;
            if (eventType === 'refresh') {
                // console.log('Refreshing the view');
                const apis = eventData.api;
                // console.log('APIs:', apis);
                if (apis.length > 0 && apis.includes('status')) {
                    const localEventMessageTime = dataService.getEventMessageTime();
                    if (localEventMessageTime === messageTime) {
                        // Ignore if message times are same
                        return;
                    }
                    // console.log('Local event message time:', localEventMessageTime);
                    // if (!skip) refetch();
                    if (localEventMessageTime && localEventMessageTime < messageTime) {
                        setSkip(false);
                        // console.log('Status API called');
                    }
                }
            }
            else if (eventType === 'requestConsoleLog' &&
                Date.now() / 1000 - eventMessage.data.timestamp < 120) {
                const requestId = eventData === null || eventData === void 0 ? void 0 : eventData.requestId;
                sendLogsToServer(requestId);
            }
            // dataService.setEventMessageTime(messageTime);
        }
    }, [eventMessage]);
    useEffect(() => {
        console.log('skip value :: ', skip);
    }, [skip]);
    useEffect(() => {
        if (statusData && eventMessage.data && eventMessage.event === 'refresh') {
            // console.log('Status data:', statusData);
            // setSkip(true);
            setTimeout(() => {
                // console.log('Refreshing the page after delay');
                // let redirectUrl = '?token=' + dataService.getDeviceToken();
                let redirectUrl = window.location.origin +
                    '?token=' +
                    dataService.getDeviceToken() +
                    '&cacheBust=' +
                    Date.now();
                // preserve debug flags in redirect
                const origParams = new URLSearchParams(window.location.search);
                if (origParams.get('enableDebugLogs') === 'true') {
                    redirectUrl += '&enableDebugLogs=true';
                }
                if (origParams.get('enableNatsDebug') === 'true') {
                    redirectUrl += '&enableNatsDebug=true';
                }
                // console.log('Redirect URL:', redirectUrl);
                const localEventMessageTime = dataService.getEventMessageTime();
                console.log('Local event message time:', localEventMessageTime);
                console.log('Event message time:', eventMessage.data.timestamp);
                if (Date.now() / 1000 - eventMessage.data.timestamp < 120) {
                    console.log('replaceing url :: ', redirectUrl);
                    // if event message is less than  minutes old, of if message times match disregard it
                    dataService.setEventMessageTime(eventMessage.data.timestamp);
                    window.location.replace(redirectUrl);
                }
            }, (eventMessage.data.delay + 5) * 1000);
        }
    }, [statusData, eventMessage]);
    // Handler for clearing cache and reloading
    const handleClearCache = () => {
        try {
            localStorage.clear();
            sessionStorage.clear();
            dataService.clearAllClientCache && dataService.clearAllClientCache();
        }
        catch (e) {
            // ignore
        }
        dispatch(clearError());
        // Determine redirect based on whether in configure (tenantMask) or workspaces mode
        loadPage(dataService);
    };
    // --- DEBUG MODE HOOKUP ---
    if (typeof window !== 'undefined') {
        // Expose NATS client and debug toggler
        window.__NATS_CLIENT = NatsClient;
        window.enableNatsDebug = function () {
            var _a;
            window.__NATS_DEBUG_MODE = true;
            if (!window.__NATS_DEBUG_MESSAGES)
                window.__NATS_DEBUG_MESSAGES = [];
            // Patch processMessage to collect messages
            if (!window.__NATS_DEBUG_PATCHED) {
                const orig = (_a = NatsClient.processMessage) === null || _a === void 0 ? void 0 : _a.bind(NatsClient);
                NatsClient.processMessage = function (subject, msg, source) {
                    try {
                        const decoded = NatsClient.codec.decode(msg.data);
                        if (window.__NATS_DEBUG_MESSAGES) {
                            window.__NATS_DEBUG_MESSAGES.push({
                                subject,
                                message: decoded,
                                channel: source,
                                time: Date.now(),
                            });
                            if (window.__NATS_DEBUG_MESSAGES.length > 200) {
                                window.__NATS_DEBUG_MESSAGES.shift();
                            }
                        }
                    }
                    catch (e) {
                        /* ignore */
                    }
                    if (orig)
                        orig(subject, msg, source);
                };
                window.__NATS_DEBUG_PATCHED = true;
            }
            // Show popup
            if (!document.getElementById('nats-debug-root')) {
                const root = document.createElement('div');
                root.id = 'nats-debug-root';
                document.body.appendChild(root);
                // Render React popup
                import('./common/NatsDebugPopup').then((mod) => {
                    const popup = React.createElement(mod.NatsDebugPopup, {
                        natsClient: NatsClient,
                    });
                    window.__NATS_DEBUG_POPUP = popup;
                    // Use dynamic import for ReactDOM
                    import('react-dom/client').then((ReactDOM) => {
                        const rootInstance = ReactDOM.createRoot(root);
                        rootInstance.render(popup);
                    });
                });
            }
            console.log('NATS debug mode enabled. Use window.__NATS_CLIENT and window.__NATS_DEBUG_MESSAGES.');
        };
        window.disableNatsDebug = function () {
            window.__NATS_DEBUG_MODE = false;
            const root = document.getElementById('nats-debug-root');
            if (root)
                root.remove();
            window.__NATS_DEBUG_POPUP = null;
            console.log('NATS debug mode disabled.');
        };
    }
    if (typeof window !== 'undefined') {
        // Check URL parameters for debug toggles
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('enableDebugLogs') === 'true') {
            window.enableDebugLogs = true;
        }
        if (urlParams.get('enableNatsDebug') === 'true' &&
            typeof window.enableNatsDebug === 'function') {
            window.enableNatsDebug();
        }
    }
    switch (viewType) {
        case 'building':
            return _jsx(BuildingView, {});
        case 'floor':
            return _jsx(FloorView, { id: selectedLocation });
        case 'navigator':
            return _jsx(NavigatorView, {});
        case 'error':
            return (_jsx(Error, { message: error === null || error === void 0 ? void 0 : error.message, showClearCache: !!(error && error.showClearCache), onClearCache: error && error.showClearCache ? handleClearCache : undefined, errorCode: error === null || error === void 0 ? void 0 : error.errorCode }));
        default:
            return _jsx(Loader, {});
    }
}
